var pubsub = require('pubsub');
var gsap = require('gsap');


module.exports = function () {
	var _galleryItems = document.querySelectorAll('.media_list_item')
	,	mediasCollection = []
	,	 counter = 0;

	/*var count = _galleryItems.length; //10

	for (let index = 0; index < count; index++) {
		const element = document.querySelector('.media_list_item[data-index='+index+']');

		
	}*/

	if(typeof(GallerySRC) != 'undefined' && GallerySRC){ 
		mediasCollection = JSON.parse(GallerySRC);
		Array.prototype.forEach.call(_galleryItems, function(el){
			el.addEventListener('click', clickItem);
		})
	} else {
		Array.prototype.forEach.call(_galleryItems, function(el){
			var _item = el
			,	media = {}
			;
			media.type = _item.getAttribute('data-type');
			media.data = _item.getAttribute('data-media');
			mediasCollection.push(media);
			_item.addEventListener('click', clickItem);
		})
	}



	function clickItem(e){ 
		e.preventDefault();
		
		var _item = this
		,	index = _item.getAttribute('data-index')
		,	data = _item.getAttribute('data-media')
		,	type = _item.getAttribute('data-type')
		;
		//pubsub.emit('lightbox:loadContent', data, type);
		pubsub.emit('lightbox:loadContent', index, mediasCollection);
		
	}
}
